export function shortenAddress(address: string = '') {
    if (!address) return address;
    return address.slice(0, 6) + '...' + address.slice(-4);
}

export function shortenEmail(email: string = '') {
    if (!email) return email;
    return email.replace(/(.{1,2})[^@]*(@.+)/, '$1***$2');
}
